export default {
  'Login.rememberMe': 'Recordar contraseña',
  'Login.login': 'Iniciar sesión',
  'Login.signUp': 'Registrarse',
  'Login.forgotPassword': 'Olvidó su contraseña?',
  'Login.inputAEmail': 'Ingrese un email',
  'Login.inputAPassword': 'Ingresa una contraseña',
  'SignUp.email': 'Mail',
  'SignUp.password': 'Constraseña',
  'SignUp.confirmPassword': 'Confirmar contraseña',
  'SignUp.notValidEmail': 'Este no es un email válido',
  'SignUp.register': 'Registrarse',
  'SignUp.login': 'Iniciar sesión',
  'Layout.Header.Organizations': 'Empresas',
  'Layout.Header.about': 'Acerca',
  'Layout.Header.profile': 'Perfil',
  'Layout.Header.logout': 'Cerrar sesión',
  'Layout.Sidebar.Dashboard': 'Inicio',
  'Layout.Sidebar.Dashboard.dashboard': 'Inicio',
  'Layout.Sidebar.Dashboard.config': 'Configuración',
  'Layout.Sidebar.Services': 'Servicios',
  'Layout.Sidebar.Services.Steam': 'Vapor',
  'Layout.Sidebar.Services.Steam.visualization': 'Visualización',
  'Layout.Sidebar.Services.Steam.trapsListing': 'Listado Trampas',
  'Layout.Sidebar.Services.Steam.trapsPlans': 'Planos Trampas',
  'Layout.Sidebar.Services.ElectricEnergy': 'Energía Eléctrica',
  'Layout.Sidebar.Services.ElectricEnergy.visualization': 'Visualización',
  'Layout.Sidebar.Services.ElectricEnergy.analysis': 'Análisis',
  'Layout.Sidebar.Services.ElectricEnergy.reports': 'Reportes',
  'Layout.Sidebar.Services.Billing': 'Facturación',
  'Layout.Sidebar.Services.Billing.reports': 'Reportes',
  'Layout.Sidebar.Services.Billing.configuration':'Configuración',
  'Layout.Sidebar.Services.Motors': 'Motores',
  'Layout.Sidebar.Services.Motors.visualization': 'Visualización',
  'Layout.Sidebar.Services.Motors.analysis': 'Análisis',
  'Layout.Sidebar.Services.Refrigeration': 'Refrigeración',
  'Layout.Sidebar.Services.Refrigeration.visualization': 'Visualización',
  'Layout.Sidebar.Services.Refrigeration.coolingStates': 'Estados Cooling',
  'Layout.Sidebar.Services.Consumption.visualization': 'Visualización',
  'Layout.Sidebar.Services.Production.visualization': 'Visualización',
  'Layout.Sidebar.Services.Consumption': 'Consumo',
  'Layout.Sidebar.Services.AirConditioner': 'Aire Acondicionado',
  'Layout.Sidebar.Services.AirConditioner.visualization': 'Visualización',
  'Layout.Sidebar.Services.Production': 'Producción',
  'Layout.Sidebar.Services.Climate': 'Clima',
  'Layout.Sidebar.Services.Climate.visualization': 'Visualización',
  'Layout.Sidebar.Analytics': 'Análisis de datos',
  'Layout.Sidebar.Services.Climate.gradeHour': 'Grados Hora',
  'Layout.Sidebar.Services.Climate.calculateHour': 'Cálculo Horas',
  'Layout.Sidebar.Analytics.Statistics': 'Estadística',
  'Layout.Sidebar.Analytics.LinearRegression': 'Regresión Lineal',
  'Layout.Sidebar.Analytics.LinearRegression.create': 'Crear Modelo',
  'Layout.Sidebar.Analytics.LinearRegression.view': 'Ver Modelos',
  'Layout.Sidebar.Analytics.Optimization': 'Optimización',
  'Layout.Sidebar.Analytics.Optimization.create': 'Crear Modelo',
  'Layout.Sidebar.Analytics.Optimization.view': 'Ver Modelos',
  'Layout.Sidebar.Analytics.forecasting': 'Pronósticos',
  'Layout.Sidebar.Analytics.Correlation.create': 'Crear Modelo',
  'Layout.Sidebar.Analytics.Correlation.view': 'Ver Modelos',
  'Layout.Sidebar.Analytics.Correlation': 'Correlación',
  'Layout.Sidebar.Analytics.linearRegressionDetails':
    'Regresión Lineal Detalles',
  'Layout.Sidebar.Analytics.optimizationModels': 'Modelos de Optimización',
  'Layout.Sidebar.Analytics.optimizationModelDetails':
    'Detalle modelo de Optimización',
  'Layout.Sidebar.Analytics.predictiveMaintenance': 'Mantenimiento Predictivo',
  'Layout.Sidebar.Reports': 'Reportes',
  'Layout.Sidebar.Reports.processes': 'Procesos',
  'Layout.Sidebar.Reports.indicators': 'Indicadores',
  'Layout.Sidebar.Reports.reports': 'Reportes',
  'Layout.Sidebar.Reports.config': 'Configuración',
  'Layout.Sidebar.Reports.Configuration': 'Configuración',
  'Layout.Sidebar.Reports.Configuration.indicators': 'Indicadores',
  'Layout.Sidebar.Reports.Configuration.processes': 'Procesos',
  'Layout.Sidebar.Alerts': 'Alertas',
  'Layout.Sidebar.Alerts.inProgress': 'En curso',
  'Layout.Sidebar.Alerts.history': 'Historial',
  'Layout.Sidebar.Alerts.config': 'Configuración',
  'Layout.Sidebar.Settings': 'Configuración',
  'Layout.Sidebar.Settings.general': 'General',
  'Layout.Sidebar.Settings.General.profile': 'Perfil',
  'Layout.Sidebar.Settings.General.organization': 'Organización',
  'Layout.Sidebar.Settings.General.plant': 'Planta',
  'Layout.Sidebar.Settings.General.section': 'Sección',
  'Layout.Sidebar.Settings.monitoring': 'Monitoreo',
  'Layout.Sidebar.Settings.Monitoring.monitorables': 'Monitoreables',
  'Layout.Sidebar.Settings.Monitoring.variables': 'Variables',
  'Layout.Sidebar.Settings.Monitoring.devices': 'Dispositivos',
  'Layout.Sidebar.Settings.devices': 'Dispositivos',
  'Layout.Sidebar.Settings.Devices.listing': 'Listado',
  'Layout.Sidebar.Settings.Devices.scaled': 'Escalados',
  'Layout.Sidebar.Settings.importData': 'Importar datos',
  'Layout.Sidebar.Settings.testLambda': 'Lambda Availability',
  'Layout.Sidebar.Analytics.Batching.create': 'Crear Modelo',
  'Layout.Sidebar.Analytics.Batching': 'Batching',
  'Layout.Sidebar.Analytics.Batching.view': 'Ver Modelos',
  
  'DataFilter.TimeRange.End': 'Fin',
  'DataFilter.TimeRange.Start': 'Inicio',

  'Co2Report.Monitorable':'Monitoreable:',
  'DataFilter.Monitorable.monitorables': 'Monitoreables',
  'DataFilter.Monitorable.planta': 'Planta',

  'DataFilter.Monitorable.variable': 'Variable',

  'DataFilter.Monitorable.variables': 'Variables',
  'DataFilter.Monitorable.selectAMonitorable': 'Campo obligatorio',
  'DataFilter.Monitorable.selectAVariable': 'Campo obligatorio',
  'DataFilter.TemporaryBasis.selectAType': 'Campo obligatorio',
  'DataFilter.TemporaryBasis.selectAFrecuency': 'Campo obligatorio',
  'DataFilter.TemporaryBasis.Data.data': 'Datos',
  'DataFilter.TemporaryBasis.Data.continuous': 'Continuo',
  'DataFilter.TemporaryBasis.Data.turn': 'Turno',
  'DataFilter.TemporaryBasis.Frecuency.frecuency': 'Frecuencia',
  'DataFilter.TemporaryBasis.Frecuency.min': 'Minuto',
  'DataFilter.TemporaryBasis.Frecuency.hour': 'Hora',
  'DataFilter.TemporaryBasis.Frecuency.day': 'Día',
  'DataFilter.TemporaryBasis.Frecuency.month': 'Mes',
  'DataFilter.TemporaryBasis.Frecuency.year': 'Año',
  'DataFilter.TemporarySelection.DateRange.month':'Mes',
  'DataFilter.TemporarySelection.DateRange.start': 'Inicio',
  'DataFilter.TemporarySelection.DateRange.end': 'Fin',
  'DataFilter.TemporarySelection.HourRange.start': 'Inicio',
  'DataFilter.TemporarySelection.selectAStartHour': 'Campo obligatorio',
  'DataFilter.TemporarySelection.HourRange.end': 'Fin',
  'DataFilter.TemporarySelection.selectAEndHour': 'Campo obligatorio',
  'DataFilter.TemporarySelection.selectRangeDates': 'Campo obligatorio',
  'DataFilter.TemporarySelection.Turn.turn': 'Turno',
  'DataFilter.TemporarySelection.Turn.selectTurn': 'Seleccione un Turno',
  'DataFilter.TemporarySelection.Turn.selectATurn': 'Campo obligatorio',
  'DataFilter.TemporarySelection.Turn.create': 'Crear',
  'DataFilter.TemporarySelection.DateRange.thisWeek': 'Esta semana',
  'DataFilter.TemporarySelection.DateRange.thisMonth': 'Este mes',
  'DataFilter.TemporarySelection.DateRange.last7days': 'Últimos 7 días',
  'DataFilter.MonthRangeSelect.DateRange.thisMonth': 'Este mes',
  'DataFilter.MonthRangeSelect.DateRange.pastHalfYear': 'Último Medio año',
  'DataFilter.MonthRangeSelect.DateRange.pastYear': 'Último año',
  'DataFilter.TemporarySelection.NewTurnModal.title': 'Crear un turno',
  'DataFilter.TemporarySelection.NewTurnModal.name': 'Nombre',
  'DataFilter.TemporarySelection.NewTurnModal.start': 'Inicio',
  'DataFilter.TemporarySelection.NewTurnModal.end': 'Fin',
  'DataFilter.TemporarySelection.NewTurnModal.cancel': 'Cancelar',
  'DataFilter.TemporarySelection.NewTurnModal.create': 'Crear',
  'DataFilter.TemporarySelection.NewTurnModal.inputName': 'Campo obligatorio',
  'DataFilter.TemporarySelection.NewTurnModal.inputEndTime':
    'Campo obligatorio',
  'DataFilter.TemporarySelection.NewTurnModal.inputStartTime':
    'Campo obligatorio',
  'DataFilter.TemporarySelection.wrongFormat': 'Formato incorrecto',
  'DataFilter.Visualization.visualization': 'Visualización',
  'DataFilter.Visualization.chart': 'Gráfico',
  'DataFilter.Visualization.selectAType': 'Campo obligatorio',
  'DataFilter.Visualization.table': 'Tabla',
  'DataFilter.Visualization.ok': 'Aceptar',
  'DataFilter.AnalysisType.locals': 'Locales',
  'DataFilter.AnalysisType.selectLocal': 'Campo obligatorio',
  'DataFilter.AnalysisType.localsPlaceholder': 'Locales',
  'DataFilter.AnalysisType.boards': 'Tableros',
  'DataFilter.AnalysisType.selectBoard': 'Campo obligatorio',
  'DataFilter.AnalysisType.boardsPlaceholder': 'Tableros',
  'DataFilter.AnalysisType.analysisType': 'Tipo de Análisis',
  'DataFilter.AnalysisType.typePlaceholder': 'Tipos',
  'DataFilter.AnalysisType.selectAnalysisType': 'Campo obligatorio',
  'DataFilter.AnalysisType.AnalysisTypes.comparative': 'Comparativo',
  'DataFilter.AnalysisType.AnalysisTypes.temporal': 'Temporal',
  'DataFilter.BoardsVisualization.boards': 'Tableros',
  'DataFilter.BoardsVisualization.selectBoard': 'Campo obligatorio',
  'DataFilter.BoardsVisualization.boardsPlaceholder': 'Tableros',
  'DataFilter.BoardsVisualization.submit': 'Aceptar',
  'DataFilter.EmptyVisualization.submit': 'Aceptar',
  'DataFilter.Periods.basePeriod': 'Perído Base',
  'DataFilter.Periods.firstPeriod': '1er Período',
  'DataFilter.Periods.secondPeriod': '2do Período',
  'DataFilter.Periods.thirdPeriod': '3er Período',
  'DataFilter.Periods.selectBasePeriod': 'Campo obligatorio',
  'DataFilter.Periods.selectFirstPeriod': 'Campo obligatorio',
  'DataFilter.Periods.selectSecondPeriod': 'Campo obligatorio',
  'DataFilter.Periods.selectThirdPeriod': 'Campo obligatorio',
  'DataFilter.TemporalWindow.temporalWindow': 'Ventana Temporal',
  'DataFilter.TemporalWindow.selectTemporalWindow': 'Campo obligatorio',
  'DataFilter.TemporalWindow.temporalWindowPlaceholder': 'Ventana Temporal',
  'DataFilter.TemporalWindow.temporalWindows.year': 'Año',
  'DataFilter.TemporalWindow.temporalWindows.month': 'Mes',
  'DataFilter.TemporalWindow.temporalWindows.day': 'Día',
  'DataFilter.TemporalWindow.temporalWindows.hour': 'Hora',
  'DataFilter.TemporalWindow.temporalWindows.min': 'Minuto',
  'DataFilter.TemporalWindow.frecuency': 'Frecuencia',
  'DataFilter.TemporalWindow.selectFrecuency': 'Campo obligatorio',
  'DataFilter.TemporalWindow.frecunecyPlaceholder': 'Frecuencia',
  'DataFilter.Optimization.max': 'Maximizar',
  'DataFilter.Optimization.min': 'Minimizar',
  'DataFilter.Optimization.selectAVariable': 'Variable a optimizar',
  'DataFilter.Optimization.variables': 'Variables',
  'DataFilter.Optimization.selectAType': 'Seleccione un tipo',
  'DataFilter.Region': 'Region',
  'DataFilter.Alerts': 'Alarmas',
  'DataFilter.ClockFormat': 'Formato',
  'DataFilter.ProcessSubmit.label':
    'Las variables seleccionadas podrán visualizarse juntas como un único proceso',
  'DataFilter.General.accept': 'Aceptar',
  'DataFilter.Processes.processes': 'Procesos',
  'DataFilter.Processes.selectAProcess': 'Campo Obligatorio',


  'DataFilter.CalculateHour.Temperature':'Temperatura',
  'DataFilter.CalculateHour.Humidity':'Humedad',
  'DataFilter.CalculateHour.Min':'Min',
  'DataFilter.CalculateHour.Max':'Max',



  'DataFilter.Indicators.indicators': 'Indicadores',
  'DataFilter.Indicators.selectAIndicator': 'Campo Obligatorio',
  'DataFilter.Indicators.empty': 'No hay indicadores',

  'DataFilter.AxisMinMax.min': 'Min',
  'DataFilter.AxisMinMax.max': 'Max',
  'DataFilter.DIMinMax.min': 'Min',
  'DataFilter.DIMinMax.max': 'Max',

  'DataFilter.Variables.continuousVariables': 'Variables continuas',
  'DataFilter.Variables.discreteVariable': 'Variable discreta',
  'DataFilter.Batching.label':
    'El modelo de Batching permite parametrizar un conjunto de variables continuas y discretas que no comparten una misma base temporal en unidades llamadas batches.',

  'DataFilter.TemporarySelection.DateRange.Billing': 'Facturación',

  'DataFilter.TemporarySelection.DateRange.subOrganization': 'Sub Empresa',
  'DataFilter.TemporarySelection.DateRange.industry':"Rubro",
  'DataFilter.Billing.Plants':'Plantas',
  'DataFilter.Billing.AutomaticBills':'Facturaciones',
  'DataFilter.Billing.SubEmpresas':'Sub Empresas',

  'Analytics.BatchingModels.batchNumber': '# Batch',
  'Analytics.BatchingModels.startDate': 'Inicio',
  'Analytics.BatchingModels.endDate': 'Fin',
  'Analytics.BatchingModels.variable': 'Variable',
  'Analytics.BatchingModels.duration': 'Duración',
  'Analytics.BatchingModels.max': 'Máximo',
  'Analytics.BatchingModels.min': 'Mínimo',
  'Analytics.BatchingModels.sum': 'Suma',
  'Analytics.BatchingModels.average': 'Promedio',
  'Analytics.BatchingModels.stdDev': 'Desviación Estandard',
  'Analytics.BatchingModelDetails.name': 'Nombre',
  'Analytics.BatchingModelDetails.frequency': 'Frecuencia',
  'Analytics.BatchingModelDetails.startDate': 'Fecha Inicio',
  'Analytics.BatchingModelDetails.endDate': 'Fecha Fin',
  'Analytics.BatchingModelDetails.startTime': 'Hora Inicio',
  'Analytics.BatchingModelDetails.endTime': 'Hora Fin',
  'Analytics.BatchingModelDetails.dataRatio': 'Data',
  'Analytics.BatchingModelDetails.creationDate': 'Fecha cración',
  'Analytics.BatchingModels.timestamp': 'timestamp',
  'Analytics.BatchingModels.value': 'Valor',
  'Analytics.BatchingModels.name': 'Nombre',
  'Analytics.BatchingModels.creationDate': 'Fecha creación',
  'Analytics.BatchingModels.status': 'Estado',
  'Analytics.BatchingModels.variables': 'Variables',
  'Analytics.BatchingModels.discreteVariable': 'Variable Discreta',
  'Analytics.BatchingModels.delete': 'Eliminar',
  'Analytics.BatchingModels.models': 'Modelos',
  'Analytics.BatchingModelDetails.discreteVariable': 'Variable Discreta',
  'Analytics.BatchingModelDetails.variables': 'Variables Continuas',

  'DataFilter.NameMonitorables.inputName': 'Campo obligatorio',
  'DataFilter.NameMonitorables.name': 'Nombre',
  'DataFilter.Variables.selectAVariable': 'Campo obligatorio',
  'DataFilter.Variables.indepVariable': 'Variable independiente',
  'DataFilter.Variables.variable': 'Variable dependiente',
  'DataFilter.CreateModel.label':
    'El modelo de Estadística permite obtener una caracterización de la(s) variable(s) seleccionadas.',
  'DataFilter.LinearRegression.max': 'Maximizar',
  'DataFilter.LinearRegression.min': 'Minimizar',
  'DataFilter.LinearRegression.objective': 'Objetivo',
  'DataFilter.LinearRegression.bestCase': 'Mejor caso',
  'DataFilter.LinearRegression.fixedRange': 'Rango Fijo',
  'DataFilter.LinearRegression.methodology': 'Metodología',
  'DataFilter.LinearRegression.range': 'Rango',
  'DataFilter.LinearRegression.filtered': 'Filtrado',
  'DataFilter.obligatoryField': 'Campo obligatorio',
  'DataFilter.Correlation.label':
    'El modelo de Correlación permite evaluar las relaciones existentes entre un grupo de variables.',
  'DataFilter.Optimization.objective': 'Objetivo',
  'DataFilter.Optimization.label':
    'El modelo de Optimización permite la combinación de Variables de Entrada que maximizan o minimzan la Variable Objetivo. Su estado puede verse en el Listado de modelos',
  'DataFilter.ImportData.selectDatetimeColumnsLabel':
    'Seleccione la(s) columnas relacionadas con la fecha.',
  'DataFilter.ImportData.inputColumnMetadata':
    'Ingrese las columnas que desea exportar y de que variable provienen:',
  'DataFilter.ImportData.importBtn': 'Importar datos',
  'DataFilter.DateTimeColumns.selectDateFormats':
    'Ingrese el formato de la(s) columna(s) seleccionada(s) anteriormente',
  'Analytics.OptimizationModels.status': 'Estado',
  'Analytics.OptimizationModels.objectiveVariable': 'Variable objetivo',
  'Analytics.OptimizationModels.dependantVariables': 'Variables dependientes',
  'Analytics.OptimizationModels.executionTime': 'Tiempo de ejecución',
  'Analytics.OptimizationModels.delete': 'Borrar modelo',
  'Analytics.StatisticModels.delete': 'Borrar modelo',
  'Analytics.StatisticModels.execute': 'Ejecutar modelo',
  'Analytics.StatisticModels.frequency': 'Frecuencia',

  'Analytics.StatisticModels.name': 'Nombre',
  'Analytics.StatisticModels.creationDate': 'Fecha creación',
  'Analytics.StatisticModels.status': 'Estado',
  'Analytics.StatisticModels.variables': 'Variables',
  'Analytics.StatisticModels.startDate': 'Fecha Inicio',
  'Analytics.StatisticModels.endDate': 'Fecha Fin',
  'Analytics.StatisticModels.models': 'Modelos',
  'Analytics.LinearRegressionModels.delete': 'Borrar modelo',
  'Analytics.LinearRegressionModels.name': 'Nombre',
  'Analytics.LinearRegressionModels.creationDate': 'Fecha creación',
  'Analytics.LinearRegressionModels.status': 'Estado',
  'Analytics.LinearRegressionModels.objectiveRange': 'Objetivo - Rango',
  'Analytics.LinearRegressionModels.depVariable': 'Variable dependiente',
  'Analytics.LinearRegressionModels.indepVariable': 'Variable independiente',
  'Analytics.LinearRegressionModels.executionTime': 'Tiempo ejecución',
  'Analytics.LinearRegressionModels.models': 'Modelos',
  'Analytics.CorrelationModels.delete': 'Borrar modelo',
  'Analytics.CorrelationModels.name': 'Nombre',
  'Analytics.CorrelationModels.creationDate': 'Fecha creación',
  'Analytics.CorrelationModels.status': 'Estado',
  'Analytics.CorrelationModels.variables': 'Variable(s)',
  'Analytics.CorrelationModels.executionTime': 'Tiempo ejecución',
  'Analytics.CorrelationModels.models': 'Modelos',
  'Analytics.CorrelationModelDetails.name': 'Nombre',
  'Analytics.CorrelationModelDetails.frequency': 'Frecuencia',
  'Analytics.CorrelationModelDetails.startDate': 'Fecha Inicio',
  'Analytics.CorrelationModelDetails.endDate': 'Fecha Fin',
  'Analytics.CorrelationModelDetails.data': 'Datos',
  'Analytics.CorrelationModelDetails.creationDate': 'Fecha creación',
  'Analytics.CorrelationModelDetails.dataRatio': 'Tasa de datos',
  'Analytics.CorrelationModelDetails.startTime': 'Hora Inicio',
  'Analytics.CorrelationModelDetails.endTime': 'Hora Fin',
  'Analytics.CorrelationModelDetails.format': 'Formato',
  'ModelDetailsBox.format': 'Formato',
  'ModelDetailsBox.submit': 'Exportar',
  'Analytics.OptimizationModelDetails.name': 'Nombre',
  'Analytics.OptimizationModelDetails.frequency': 'Frecuencia',
  'Analytics.OptimizationModelDetails.startDate': 'Fecha Inicio',
  'Analytics.OptimizationModelDetails.endDate': 'Fecha Fin',
  'Analytics.OptimizationModelDetails.data': 'Datos',
  'Analytics.OptimizationModelDetails.creationDate': 'Fecha creación',
  'Analytics.OptimizationModelDetails.dependantVariables':
    'Variables dependientes',
  'Analytics.OptimizationModelDetails.startTime': 'Hora Inicio',
  'Analytics.OptimizationModelDetails.endTime': 'Hora Fin',
  'Analytics.OptimizationModelDetails.format': 'Formato',
  'Analytics.OptimizationModelDetails.objectiveVariable': 'Variable objetivo',
  'Layout.Sidebar.Analytics.Statistics.create': 'Crear Modelo',
  'Layout.Sidebar.Analytics.Statistics.executions': 'Ejecuciones',

  'Layout.Sidebar.Analytics.Statistics.view': 'Ver Modelos',
  'Layout.Sidebar.Analytics.Statistics.view.executions': 'Ejecuciones',
  'Layout.Sidebar.Analytics.Statistics.view.executions.result': 'Resultados',

  'Analytics.StatisticsModelDetails.variable': 'Variable',
  'Analytics.StatisticsModelDetails.unit': 'Unidad',
  'Analytics.StatisticsModelDetails.min': 'Mínimo',
  'Analytics.StatisticsModelDetails.max': 'Máximo',
  'Analytics.StatisticsModelDetails.average': 'Promedio',
  'Analytics.StatisticsModelDetails.mean': 'Media',
  'Analytics.StatisticsModelDetails.standardDesviation': 'Dev. stándard',
  'Analytics.StatisticsModelDetails.conform': '% conforme',
  'Analytics.StatisticsModelDetails.dataRate': 'Tasa Datos',
  'Analytics.LinearRegressionModelDetails.dataRate': 'Tasa Datos',
  'Analytics.LinearRegressionModelDetails.name': 'Nombre',
  'Analytics.LinearRegressionModelDetails.frequency': 'Frecuencia',
  'Analytics.LinearRegressionModelDetails.startDate': 'Fecha Inicio',
  'Analytics.LinearRegressionModelDetails.endDate': 'Fecha Fin',
  'Analytics.LinearRegressionModelDetails.startTime': 'Hora Inicio',
  'Analytics.LinearRegressionModelDetails.endTime': 'Hora Fin',
  'Analytics.LinearRegressionModelDetails.methodology': 'Metodologia',
  'Analytics.LinearRegressionModelDetails.objectiveVariable':
    'Variable dependiente',
  'Analytics.LinearRegressionModelDetails.filtered': 'Filtrado',
  'Analytics.LinearRegressionModelDetails.data': 'Data',
  'Analytics.LinearRegressionModelDetails.objective': 'Objetivo',
  'Analytics.LinearRegressionModelDetails.creationDate': 'Fecha creacion',
  'DataFilter.General.createModel': 'Crear modelo',

  'DataFilter.LinearRegression.selectAVariable': 'Variable objetivo',
  'DataFilterComponent.MonitorableVariable': 'Selección de entrada',
  'DataFilterComponent.MonitorableVariable.monitorables': 'Monitoreables',
  'DataFilter.Co2.sensores':'Sensores',

  'DataFilterComponent.MonitorableVariable.variable': 'Variables',
  'DataFilterComponent.temporarySelection': 'Base temporal',
  'DataFilterComponent.optimization': 'Objetivo',
  'DataFilter.Name.Name': 'Nombre',
  'DataFilter.TemporarySelection.minutesFromNow': 'Tiempo atrás',
  'Settings.General.UserAdminTable.addUser': 'Agregar Usuario',
  'Settings.General.Profile.name': 'Nombre',
  'Settings.General.Profile.lastname': 'Apellido',
  'Settings.General.Profile.email': 'Email',
  'Settings.General.Profile.type': 'Tipo',
  'Settings.General.Profile.permits': 'Permisos',
  'Settings.General.Profile.admin': 'Administrador',
  'Settings.General.Profile.ADMIN': 'Planta/Seccion/Monit',
  'Settings.General.Profile.SUPER': 'Empresas',
  'Settings.General.Profile.BILLS': 'Empresas',
  'Settings.General.Profile.MONIT': 'Monitoreables',
  'Settings.General.Profile.PLANT': 'Plantas',
  'Settings.General.Profile.SECTION': 'Secciones',
  'Settings.General.Organization.plants': 'Plantas',
  'Settings.General.Organization.sections': 'Nro. Secciones',
  'Settings.General.Organization.user': 'Usuario',
  'Settings.General.Organization.admin': 'Administrador',
  'Settings.General.Organization.name': 'Nombre',
  'Settings.General.Organization.phone': 'Teléfono',
  'Settings.General.Organization.postalCode': 'Código postal',
  'Settings.General.Organization.address': 'Dirección',
  'Settings.General.Plant.section': 'Sección',
  'Settings.General.Plant.user': 'Usuario',
  'Settings.General.Plant.admin': 'Administrador',
  'Settings.General.Plant.phone': 'Teléfono',
  'Settings.General.Plant.address': 'Dirección',
  'Settings.General.Plant.postalCode': 'Código Postal',
  'Settings.General.Plant.minTemp': 'Temperatura referencia frío',
  'Settings.General.Plant.maxTemp': 'Temperatura referencia calor',
  'Settings.General.Plant.wheatherStation': 'Estación meteorologica',
  'Settings.General.Plant.saveChanges': 'Guardar cambios',
  'Settings.General.Plant.cancel': 'Cancelar',
  'Settings.General.Plant.edit': 'Editar',
  'Settings.General.Plant.timeZone': 'Zona Horaria',
  'Settings.General.Plant.addSection': 'Agregar Sección',
  'Settings.General.Plant.addUser': 'Agregar Usuario',
  'Settings.General.Plants.plants': 'Plantas',
  'Settings.General.Plants.plantTable': 'Plantas',
  'Settings.General.Plants.nSectionsTable': 'Nro Secciones',
  'Settings.General.Plants.nMonitorablesTable': 'Nro Monitoreables',
  'Settings.General.Section.monitorable': 'Monitoreables',
  'Settings.General.Section.monitorableType': 'Tipo',
  'Settings.General.Section.user': 'Usuario',
  'Settings.General.Section.admin': 'Administrador',
  'Settings.General.Section.addUser': 'Agregar usuario',
  'Settings.General.Section.sectionNameTable': 'Sección',
  'Settings.General.Section.plantNameTable': 'Planta',
  'Settings.General.Section.nMonitorablesTable': 'N Monitoreables',
  'Settings.General.Section.sections': 'Secciones',
  'Settings.Monitoring.Monitorable.tableName': 'Nombre',
  'Settings.Monitoring.Monitorable.tableType': 'Tipo',
  'Settings.Monitoring.Monitorable.tableConnection': 'Conexión',
  'Settings.Monitoring.Monitorable.tableEnabled': 'Habilitado',
  'Settings.Monitoring.Monitorable.tableService': 'Servicio',
  'Settings.Monitoring.Monitorable.tablePlant': 'Planta',
  'Settings.Monitoring.Monitorable.tableSection': 'Sección',
  'Settings.Monitoring.Monitorable.tableEdit': 'Editar',
  'Settings.Monitoring.Monitorable.tableDelete': 'Eliminar',
  'Settings.Monitoring.Monitorable.addMonitorable': 'Agregar Monitoreable',
  'Settings.Monitoring.Monitorable.deletePopUpTitle':
    'Está seguro que desea borrar este monitoreable?',
  'Settings.Monitoring.Monitorable.cancelDelete': 'Cancelar',
  'Settings.Monitoring.Monitorable.deleteOk': 'Borrar',
  'Settings.Monitoring.Monitorable.Modal.title': 'Agregar Monitoreable',
  'Settings.Monitoring.Monitorable.Modal.name': 'Nombre',
  'Settings.Monitoring.Monitorable.Modal.type': 'Tipo',
  'Settings.Monitoring.Monitorable.Modal.organization': 'Organización',
  'Settings.Monitoring.Monitorable.Modal.plant': 'Planta',
  'Settings.Monitoring.Monitorable.Modal.section': 'Seccion',
  'Settings.Monitoring.Monitorable.Modal.boardType': 'Tipo Tablero',
  'Settings.Monitoring.Monitorable.Modal.cancel': 'Cancelar',
  'Settings.Monitoring.Monitorable.Modal.create': 'Crear',
  'Settings.Monitoring.Monitorable.Modal.save': 'Guardar',
  'Settings.Monitoring.Monitorable.Modal.inputName': 'Ingrese un Nombre',
  'Settings.Monitoring.Monitorable.Modal.inputType': 'Seleccione un tipo',
  'Settings.Monitoring.Monitorable.Modal.inputOrganization':
    'Seleccione una Organización',
  'Settings.Monitoring.Monitorable.Modal.inputPlant': 'Seleccione una Planta',
  'Settings.Monitoring.Monitorable.Modal.inputSection':
    'Seleccione una Sección',
  'Settings.Monitoring.Monitorable.Modal.inputBoardType':
    'Seleccione un tipo de tablero',
  'Settings.Monitoring.Monitorable.Modal.service': 'Servicio',
  'Settings.Monitoring.Monitorable.Modal.serviceInput':
    'Seleccione un Servicio',
  'Settings.Monitoring.Monitorable.Modal.checkConnection':
    'Chequear conexión',  
  'Settings.Monitoring.Monitorable.Modal.desconectionEmail': 'Email de desconexiones',
  'Settings.Monitoring.Variable.addVariable': 'Agregar Variable',
  'Settings.Monitoring.Variable.searchInput': 'Buscar palabra',
  'Settings.Monitoring.Variable.tableVariable': 'Variable',
  'Settings.Monitoring.Variable.tableType': 'Tipo',
  'Settings.Monitoring.Variable.tableMonitorable': 'Monitoreable',
  'Settings.Monitoring.Variable.tableUnit': 'Unidad',
  'Settings.Monitoring.Variable.tableScaleA': 'Escalar A',
  'Settings.Monitoring.Variable.tableScaleB': 'Escalar B',
  'Settings.Monitoring.Variable.tableFrecuency': 'Frecuencia',
  'Settings.Monitoring.Variable.tableTemporalBasis': 'Base Temporal',
  'Settings.Monitoring.Variable.tableRawMaterials': 'Materia Prima',
  'Settings.Monitoring.Variable.Modal.title': 'Agregar Variable',
  'Settings.Monitoring.Variable.Modal.cancel': 'Cancelar',
  'Settings.Monitoring.Variable.Modal.create': 'Crear',
  'Settings.Monitoring.Variable.Modal.inputName': 'Ingrese un Nombre',
  'Settings.Monitoring.Variable.Modal.name': 'Nombre',
  'Settings.Monitoring.Variable.Modal.monitorable': 'Monitoreable',
  'Settings.Monitoring.Variable.Modal.dataOrigin': 'Origen de Datos',
  'Settings.Monitoring.Variable.Modal.type': 'Tipo',
  'Settings.Monitoring.Variable.Modal.frecuency': 'Frecuencia',
  'Settings.Monitoring.Variable.Modal.temporalBasis': 'Base Temporal',
  'Settings.Monitoring.Variable.Modal.scaleA': 'Escalar A',
  'Settings.Monitoring.Variable.Modal.scaleB': 'Escalar B',
  'Settings.Monitoring.Variable.Modal.unit': 'Unidad',
  'Settings.Monitoring.Variable.Modal.rawMaterials': 'Materia Prima',
  'Settings.Monitoring.Variable.Modal.position': 'Posicion',
  'Settings.Monitoring.Variable.Modal.inputMonitorable':
    'Seleccione un Monitoreable',
  'Settings.Monitoring.Variable.Modal.inputDataOrigin':
    'Seleccione un Origen de Datos',
  'Settings.Monitoring.Variable.Modal.inputType': 'Seleccione un Tipo',
  'Settings.Monitoring.Variable.Modal.inputFrecuency':
    'Seleccione una Frecuecnia',
  'Settings.Monitoring.Variable.Modal.inputTemporalBasis':
    'Seleccione una Base Temporal',
  'Settings.Monitoring.Variable.Modal.inputScaleA': 'Ingrese Escalar A',
  'Settings.Monitoring.Variable.Modal.inputScaleB': 'Ingrese Escalar B',
  'Settings.Monitoring.Variable.Modal.inputUnit': 'Ingrese una Unidad',
  'Settings.Monitoring.Variable.Modal.inputRawMaterials':
    'Seleccione una Materia Prima',
  'Settings.Monitoring.Variable.Modal.inputPosition': 'Seleccione Posición',
  'Settings.Devices.Listing.modbusID': 'ID',
  'Settings.Devices.Listing.host': 'Host',
  'Settings.Devices.Listing.port': 'Puerto',
  'Settings.Devices.Listing.firstRegister': 'Primer Registro',
  'Settings.Devices.Listing.quantity': 'Cantidad',
  'Settings.Devices.Listing.frecuency': 'Frecuencia',
  'Settings.Devices.Listing.tableEdit': 'Editar',
  'Settings.Devices.Listing.tableDelete': 'Eliminar',
  'Settings.Devices.Listing.localsID': 'ID',
  'Settings.Devices.Listing.route': 'Ruta',
  'Settings.Devices.Listing.iotID': 'ID',
  'Settings.Devices.Listing.arn': 'ARN',
  'Settings.Devices.Listing.addDevice': 'Agregar Dispositivo',
  'Settings.Devices.Listing.modbusAddBtnLabel': 'Agregar Dispositivo',
  'Settings.Devices.Listing.localsAddBtnLabel': 'Agregar Carpeta',
  'Settings.Devices.Listing.iotAddBtnLabel': 'Agregar IoT',
  'Settings.Devices.Scaled.tableID': 'ID',
  'Settings.Devices.Scaled.tableHost': 'Ruta/Host',
  'Settings.Devices.Scaled.tablePosition': 'Posicion',
  'Settings.Devices.Scaled.tableVariable': 'Variable',
  'Settings.Devices.Scaled.tableScaleA': 'Escalar A',
  'Settings.Devices.Scaled.tableScaleB': 'Escalar B',
  'Settings.Devices.Scaled.tableIsCounter': 'Es contador',
  'Settings.Devices.Scaled.tableMaxValue': 'Valor máximo',
  'Settings.Devices.Scaled.tableEdit': 'Editar',
  'Settings.Devices.Scaled.tableDelete': 'Eliminar',
  'Settings.Devices.Scaled.addLabel': 'Agregar',
  'Settings.ImportData.tablePosition': 'Posición',
  'Settings.ImportData.tableMonitorable': 'Monitoreable',
  'Settings.ImportData.tableVariable': 'Variable',
  'Settings.ImportData.tableScaleA': 'Escalar A',
  'Settings.ImportData.tableScaleB': 'Escalar B',
  'Settings.ImportData.fileFormat': 'Formato de Archivo',
  'Settings.ImportData.file': 'Archivo',
  'Settings.ImportData.preview': 'Vista Previa',
  'Settings.ImportData.clickToUpload': 'Seleccionar Archivo',
  'Settings.ImportData.validate': 'Validar',
  'Settings.ImportData.save': 'Guardar',
  'Settings.ImportData.selectFileFirst':
    'Seleccione un archivo antes de validar',
  'Settings.ImportData.columnName': 'Nombre',
  'Settings.ImportData.available': 'Exportar',
  'Settings.ImportData.fileHasHeaders': '¿El archivo contiene encabezado?',
  'ForgotPassword.notValidEmail': 'Este no es un email valido',
  'ForgotPassword.email': 'Mail',
  'ForgotPassword.explanationLabel':
    'Ingrese el email que uso para registrarse. Le mandaremos un correo con un código para reestablecer su contraseña.',
  'ForgotPassword.enterAnEmail': 'Ingrese un email',
  'ForgotPassword.send': 'Mandar código',
  'ForgotPassword.checkYourEmail': 'Te enviamos un mail con el código',
  'ForgotPassword.login': 'Ir al login',
  'ConfirmPassword.notValidEmail': 'Este no es un email valido.',
  'ConfirmPassword.email': 'Mail',
  'ConfirmPassword.enterAnEmail': 'Ingrese un email',
  'ConfirmPassword.code': 'Codigo',
  'ConfirmPassword.enterACode': 'Ingresar código',
  'ConfirmPassword.enterAPassword': 'Ingrese una contraseña',
  'ConfirmPassword.password': 'Contraseña',
  'ConfirmPassword.confirmPassword': 'Repetir Contraseña',
  'ConfirmPassword.instructions': 'Ingrese el código y resetea tu contraseña.',
  'ConfirmPassword.reset': 'Resetear',
  'ConfirmPassword.login': 'Ir al login',
  'Analytics.OptimizationModels.name': 'Nombre',
  'Analytics.OptimizationModels.models': 'Modelos',
  'Analytics.OptimizationModels.optimizationVariable': 'Variable que optimiza',
  'Analytics.OptimizationModels.creationDate': 'Fecha de creación',
  'Analytics.OptimizationModels.details': 'Detalles',
  'Analytics.OptimizationModelDetails.entryVariable': 'Variable de entrada',
  'Analytics.OptimizationModelDetails.type': 'Tipo',
  'Analytics.OptimizationModelDetails.valueRange': 'Rango de valores posibles',
  'Analytics.OptimizationModelDetails.optimumValue': 'Valor óptimo',
  'Analytics.OptimizationModelDetails.outcomeVariable': 'Variable de salida',
  'Analytics.OptimizationModelDetails.expectedValue': 'Valor esperado',
  'Analytics.OptimizationModelDetails.uncertainty': 'Incertidumbre',
  'Analytics.LinearRegressionDetails.entryVariable': 'Variable de entrada',
  'Analytics.LinearRegressionDetails.coefficient': 'Coeficiente',
  'Analytics.LinearRegressionDetails.outcomeVariable': 'Variable de salida',
  'Analytics.LinearRegressionDetails.formula': 'Fórmula',
  'Analytics.StatisticsModelDetails.belowMinPercentage': 'Abajo mínimo',
  'Analytics.StatisticsModelDetails.rangePercentage': 'Rango',
  'Analytics.StatisticsModelDetails.aboveMaxPercentage': 'Arriba máximo',

  'Alerts.History.startTime': 'Inicio',
  'Alerts.History.endTime': 'Fin',
  'Alerts.InProgress.id': 'Id',
  'Alerts.InProgress.alerts': 'Alertas en curso',
  'Alerts.InProgress.name': 'Nombre',
  'Alerts.InProgress.variable': 'Variable',
  'Alerts.InProgress.value': 'Valor',
  'Alerts.InProgress.hour': 'Hora',
  'Alerts.History.id': 'Id',
  'Alerts.History.alerts': 'Historial de Alertas',
  'Alerts.History.name': 'Nombre',
  'Alerts.History.variable': 'Variable',
  'Alerts.History.value': 'Valor',
  'Alerts.History.hour': 'Hora',
  'Alerts.History.dateOfShutdown': 'Fecha de apague',
  'Alerts.Configuration.id': 'Id',
  'Alerts.Configuration.configuration': 'Configuracion',
  'Alerts.Configuration.name': 'Nombre',
  'Alerts.Configuration.rules': 'Reglas',
  'Alerts.Configuration.mails': 'Mails',
  'Alerts.Configuration.edit': 'Editar',
  'Alerts.Configuration.delete': 'Eliminar',
  'ChartConfig.axisAvailability': 'Habilitado',
  'ChartConfig.axis': 'Eje',
  'ChartConfig.min': 'Mínimo',
  'ChartConfig.max': 'Máximo',



  //New Menu Organization
  //Production
  'Layout.Sidebar.Production': 'Producción',
  'Layout.Sidebar.Production.Visualization': 'Visualización',
  'Layout.Sidebar.Production.Analysis': 'Análisis',
  'Layout.Sidebar.Production.Configuration': 'Configuración',
  
  //Consumption
  'Layout.Sidebar.Consumption': 'Consumos',
  'Layout.Sidebar.Consumption.Visualization': 'Visualización',

  
  //AirQuality
  
  'Layout.Sidebar.AirQuality': 'Calidad del Aire',
  'Layout.Sidebar.AirQuality.Report': 'Reportes',

  //Processes
  'Layout.Sidebar.Processes': 'Procesos',
  'Layout.Sidebar.Processes.Visualization': 'Visualización',
  'Layout.Sidebar.Processes.Configuration': 'Configuración',

  //Indicators
  'Layout.Sidebar.Indicators': 'Indicadores',
  'Layout.Sidebar.Indicators.Visualization': 'Visualización',
  'Layout.Sidebar.Indicators.Configuration': 'Configuración',
};



// WEBPACK FOOTER //
// ./lang/esMessages.js